import React from 'react';
import PropTypes from 'prop-types';
import SimpleCheckbox from '../../../../common/simpleCheckbox';

const ServiceItem = ({ service }) => (
  <div className="c-table-card__row c-table-card__row--transparent">
    <div className="c-table-card__cell u-2/10">
      <SimpleCheckbox
        key={service.shopId}
        id={`services.${service.id}`}
        name={`services.${service.id}`}
      />
    </div>
    <div className="c-table-card__cell u-4/10">{service.name}</div>
    <div className="c-table-card__cell u-4/10">
      {(service.categories || []).map(({ name }) => name).join(', ')}
    </div>
  </div>
);

ServiceItem.propTypes = {
  service: PropTypes.object.isRequired, // eslint-disable-line
};

export default ServiceItem;
